import { render, staticRenderFns } from "./boxDetail.vue?vue&type=template&id=22b197af&scoped=true&"
import script from "./boxDetail.vue?vue&type=script&lang=js&"
export * from "./boxDetail.vue?vue&type=script&lang=js&"
import style0 from "./boxDetail.vue?vue&type=style&index=0&id=22b197af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b197af",
  null
  
)

component.options.__file = "boxDetail.vue"
export default component.exports